import App from "@/App.vue";

export default [
  {
    path: "/grupos-modalidades",
    name: "modality",
    component: App,
    redirect: { name: "list modality" },
    children: [
      {
        path: "",
        name: "list modality",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/ListModality.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Grupos de Modalidades",
              disabled: false,
              link: false,
              to: { name: "modality" }
            }
          ],
          displayName: "Lista Grupos Modalidades - Lockton",
          requiresAuth: true,
          permissionRoute: "visualizar_modalidade"
        }
      },
      {
        path: "/modalidade/:id/sub-modalidades",
        name: "list sub-modality",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/ListSubModality.vue"
          ),
        meta: {
          breadcrumb: [
            {
              text: "Tradicional",
              disabled: false,
              link: true,
              to: { name: "modality" }
            }
          ],
          displayName: "Lista Sub-Modalidades - Lockton",
          requiresAuth: true,
          permissionRoute: "visualizar_modalidade"
        }
      }
    ]
  }
];
